import React from 'react'
import {Modal, Button} from 'react-bootstrap'
import {useNavigate} from 'react-router-dom'

type QuotaDowngradeBlockModalProps = {
  show: boolean
  message?: string
  onClose: () => void
}

const QuotaDowngradeBlockModal: React.FC<QuotaDowngradeBlockModalProps> = ({
  show,
  message,
  onClose,
}) => {
  const navigate = useNavigate()
  const onDelete = () => {
    navigate('/wallet-card')
  }
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Cannot downgrade</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className='mb-0'>
          {message || 'Please delete some wallet cards before downgrading your plan.'}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='primary' onClick={onClose}>
          Got it
        </Button>
        <Button variant='primary' onClick={onDelete}>
          Delete cards
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default QuotaDowngradeBlockModal
